import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'jquery/dist/jquery.min.js';
import 'bootstrap/dist/js/bootstrap.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import "@popperjs/core"
import stylesMed from "./stylesMed"
import { Map, GoogleApiWrapper, Marker } from 'google-maps-react';
import { ArrowBackCircle } from 'react-ionicons'

export class Tracking extends React.Component {

    constructor() {
        super();
        this.state = {
            latitude: 0,
            longitude: 0,
            user: ""
        }
    }

    async componentDidMount() {
        const coords = JSON.parse(localStorage.getItem('HCPCoords'));
        const user = localStorage.getItem('User');
        await this.setState({ latitude: coords.latitude, longitude: coords.longitude, user: JSON.parse(user) });
    }

    render() {
        if (this.state.latitude !== 0 && this.state.longitude !== 0) {
            return (
                <div className="container-fluid vh-100" style={stylesMed.mainBackgroundColor}>
                    <div className="row pt-3">
                        <div className="col">
                            <ArrowBackCircle className="btn" onClick={() => this.props.history.goBack()} color={'#00bfff'} height="50px" width="50px" />
                        </div>
                    </div>
                    <Map
                        google={this.props.google}
                        zoom={14}
                        style={stylesMed.maps}
                        initialCenter={{
                            lat: parseFloat(this.state.latitude),
                            lng: parseFloat(this.state.longitude)
                        }}
                    >
                        <Marker
                            name={this.state.user}
                        />
                    </Map>
                </div>
            )
        }
        else {
            return (
                <div className="container-fluid vh-100" style={stylesMed.mainBackgroundColor}>
                    <div className="row pt-3">
                        <div className="col">
                            <ArrowBackCircle className="btn" onClick={() => this.props.history.goBack()} color={'#00bfff'} height="50px" width="50px" />
                        </div>
                    </div>
                </div>
            )
        }
    }
}
export default GoogleApiWrapper({
    apiKey: ("AIzaSyAKWAPSaonhKOAocStUTci9IRysL7C2Ygs")
})(Tracking)